import { useEffect, useState } from 'react';
import { useUserContext } from '../../context/user.context';
import { Convertor } from '../../utils/convertor';
import { TokenEnum } from '../../types/enums/token.enum';
import { MissionCategoryEnum } from '../../types/enums/missionCategory.enum';

export const useAirdrop = () => {
  const { pointsData, airdropData } = useUserContext();
  const [airdropPoints, setAirdropPoints] = useState(0);
  const [ethMultiplier, setEthMultiplier] = useState(1);
  const [stablecoinMultiplier, setStablecoinMultiplier] = useState(1);
  const [ethAmountBridged, setEthAmountBridged] = useState(0);
  const [ozUSDAmountBridged, setozUSDAmountBridged] = useState(0);
  const [isEligible, setIsEligible] = useState(false);
  const [isAirdropPaused, setIsAirdropPaused] = useState(false);
  const [claimed, setClaimed] = useState(true);
  const [airdropTokens, setAirdropTokens] = useState(0);

  useEffect(() => {
    if (pointsData) {
      setIsAirdropPaused(pointsData.airdropPaused);
      // if (!pointsData.airdropPaused) {
      setEthMultiplier(
        pointsData.currentMultiplier[MissionCategoryEnum.GENERAL] +
          pointsData.currentMultiplier[MissionCategoryEnum.ETH] || 0,
      );
      setStablecoinMultiplier(
        pointsData.currentMultiplier[MissionCategoryEnum.GENERAL] +
          pointsData.currentMultiplier[MissionCategoryEnum.STABLECOIN] || 0,
      );
      setEthAmountBridged(
        Convertor.weiToEth(pointsData.amountBridged[TokenEnum.ETH] || 0),
      );
      setozUSDAmountBridged(
        Convertor.weiToEth(pointsData.amountBridged[TokenEnum.OZUSD] || 0),
      );

      if (pointsData.dailyPoints && !pointsData.airdropPaused) {
        const timeoutSeconds = 2;

        const reCalculatePoints = () => {
          const pointsPerInterval =
            (pointsData.dailyPoints / (24 * 60 * 60)) * timeoutSeconds;

          setAirdropPoints(
            (airdropPoints) =>
              (airdropPoints || pointsData.pointsAccumulated) +
              pointsPerInterval,
          );
        };

        const intervalId = setInterval(
          reCalculatePoints,
          timeoutSeconds * 1000,
        );

        return () => clearInterval(intervalId);
      } else {
        if (pointsData.pointsAccumulated) {
          setAirdropPoints(pointsData.pointsAccumulated);
        } else {
          setAirdropPoints(0);
        }
      }
      // }
    }
  }, [pointsData]);

  useEffect(() => {
    if (!!airdropData) {
      setIsEligible(airdropData?.eligible);
      setAirdropTokens(Convertor.weiToEth(airdropData.tokenAmount || 0));
    }
  }, [airdropData]);

  return {
    airdropPoints,
    ethMultiplier,
    stablecoinMultiplier,
    ethAmountBridged,
    ozUSDAmountBridged,
    isEligible,
    airdropTokens,
    claimed,
    setClaimed,
    isAirdropPaused,
  };
};
